import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useGlobalStore } from '@/stores/useGlobalStore';
import { UserRole } from '@/services/api';
import { NotFoundPage } from '@/public/NotFoundPage';

type RequireAuthProps = { allowedRoles: UserRole[]; children: ReactNode };

export const Authenticated = ({ allowedRoles, children }: RequireAuthProps) => {
  const user = useGlobalStore((state) => state.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (user && !allowedRoles.includes(user.role)) {
    return <NotFoundPage />;
  }

  return children as JSX.Element;
};
